import React from "react";
import Formulario from "./components/formulario/Formulario";
import "./App.css";

function App() {
  return (
    <div className="app-root">
      <Formulario />
    </div>
  );
}

export default App;
